<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'AvailableSpacesModule';

export default {
  name: 'WrapperAvailableSpaces',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
